import { c as _c } from "react-compiler-runtime";
import { useCallback, useContext } from 'react';
import { APP_NAME, COMMENTS_FILTER, CTA_URL, HIDE_EMBEDDED_COMMENTS, IS_COMMENT_MODE_ACTIVE, IS_EMBEDDED_COMMENTS_ENABLED, IS_OPEN, MODULES_WITH_REPLIES, OBJECT_ID, OBJECT_TYPE, TAB, COMMENT_THREAD, ASSETS_LAST_UPDATED, ENABLED_FEATURES, IS_EMBEDDED_POPOVER_OPEN, EMBEDDED_POPOVER_PLACEMENT, EMBEDDED_COMMENT_COORDINATES, EMBEDDED_MODULE_ID, EMBEDDED_META_DESCRIPTION, IS_EMBEDDED_OPEN_FROM_COMMENT_MODE, COMMENTABLE_AREA_CLICK_COORDINATES, DELETE_COMMENT_REQUEST, EMBEDDED_POPOVER_ANCHOR_SELECTOR } from '../constants/CollaborationSidebarStateProperties';
import CollaborationSidebarStateContext from '../contexts/CollaborationSidebarStateContext';
import { getSanitizedTab } from '../utils/tab';
import { deleteCommentOnModuleAction, getEmptyCollaborationSidebarStateContext } from '../utils';
export default function useCollaborationSidebarState(t0) {
  "use memo";

  const $ = _c(58);
  const {
    allowNoContext
  } = t0 === undefined ? {} : t0;
  const contextVal = useContext(CollaborationSidebarStateContext);
  if (!contextVal && !allowNoContext) {
    throw new Error("Using useCollaborationSidebarState outside of a CollaborationSidebarStateContext");
  }
  let t1;
  if ($[0] !== contextVal) {
    t1 = contextVal || getEmptyCollaborationSidebarStateContext();
    $[0] = contextVal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = t1;
  const t2 = collaborationSidebarState[APP_NAME];
  const t3 = collaborationSidebarState[ENABLED_FEATURES];
  const t4 = collaborationSidebarState[OBJECT_TYPE];
  const t5 = collaborationSidebarState[OBJECT_ID];
  const t6 = collaborationSidebarState[CTA_URL];
  const t7 = collaborationSidebarState[IS_EMBEDDED_COMMENTS_ENABLED];
  const t8 = collaborationSidebarState[IS_OPEN];
  const t9 = collaborationSidebarState[TAB];
  const t10 = collaborationSidebarState[MODULES_WITH_REPLIES];
  const t11 = collaborationSidebarState[IS_COMMENT_MODE_ACTIVE];
  const t12 = collaborationSidebarState[HIDE_EMBEDDED_COMMENTS];
  const t13 = collaborationSidebarState[COMMENT_THREAD];
  const t14 = collaborationSidebarState[COMMENTS_FILTER];
  const t15 = collaborationSidebarState[ASSETS_LAST_UPDATED];
  const t16 = collaborationSidebarState[IS_EMBEDDED_POPOVER_OPEN];
  const t17 = collaborationSidebarState[EMBEDDED_POPOVER_PLACEMENT];
  const t18 = collaborationSidebarState[EMBEDDED_COMMENT_COORDINATES];
  const t19 = collaborationSidebarState[EMBEDDED_MODULE_ID];
  const t20 = collaborationSidebarState[EMBEDDED_POPOVER_ANCHOR_SELECTOR];
  const t21 = collaborationSidebarState[EMBEDDED_META_DESCRIPTION];
  const t22 = collaborationSidebarState[IS_EMBEDDED_OPEN_FROM_COMMENT_MODE];
  const t23 = collaborationSidebarState[COMMENTABLE_AREA_CLICK_COORDINATES];
  const t24 = collaborationSidebarState[DELETE_COMMENT_REQUEST];
  let t25;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t25 = tab => onUpdateCollaborationSidebarState({
      [IS_OPEN]: true,
      [TAB]: getSanitizedTab(tab)
    });
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t25;
  } else {
    t25 = $[3];
  }
  const t26 = t25;
  let t27;
  if ($[4] !== onUpdateCollaborationSidebarState) {
    t27 = t28 => {
      const {
        isCommentModeActive,
        commentThread,
        ctaCommentId,
        SELECTED_ASSET,
        commentsFilter
      } = t28 === undefined ? {} : t28;
      return onUpdateCollaborationSidebarState({
        isOpen: true,
        tab: "comments",
        isCommentModeActive: isCommentModeActive !== null && isCommentModeActive !== void 0 ? isCommentModeActive : true,
        commentsFilter: commentsFilter !== null && commentsFilter !== void 0 ? commentsFilter : "open",
        commentThread: commentThread !== null && commentThread !== void 0 ? commentThread : undefined,
        ctaCommentId: ctaCommentId !== null && ctaCommentId !== void 0 ? ctaCommentId : undefined,
        SELECTED_ASSET: SELECTED_ASSET !== null && SELECTED_ASSET !== void 0 ? SELECTED_ASSET : undefined
      });
    };
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t27;
  } else {
    t27 = $[5];
  }
  const t28 = t27;
  let t29;
  if ($[6] !== onUpdateCollaborationSidebarState) {
    t29 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "tasks",
      isCommentModeActive: false
    });
    $[6] = onUpdateCollaborationSidebarState;
    $[7] = t29;
  } else {
    t29 = $[7];
  }
  const t30 = t29;
  let t31;
  if ($[8] !== onUpdateCollaborationSidebarState) {
    t31 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "calendar",
      isCommentModeActive: false
    });
    $[8] = onUpdateCollaborationSidebarState;
    $[9] = t31;
  } else {
    t31 = $[9];
  }
  const t32 = t31;
  let t33;
  if ($[10] !== onUpdateCollaborationSidebarState) {
    t33 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "approvals",
      isCommentModeActive: false
    });
    $[10] = onUpdateCollaborationSidebarState;
    $[11] = t33;
  } else {
    t33 = $[11];
  }
  const t34 = t33;
  let t35;
  if ($[12] !== onUpdateCollaborationSidebarState) {
    t35 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "copilot",
      isCommentModeActive: false
    });
    $[12] = onUpdateCollaborationSidebarState;
    $[13] = t35;
  } else {
    t35 = $[13];
  }
  const t36 = t35;
  let t37;
  if ($[14] !== onUpdateCollaborationSidebarState) {
    t37 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "activityFeed",
      isCommentModeActive: false
    });
    $[14] = onUpdateCollaborationSidebarState;
    $[15] = t37;
  } else {
    t37 = $[15];
  }
  const t38 = t37;
  let t39;
  if ($[16] !== onUpdateCollaborationSidebarState) {
    t39 = t40 => {
      const {
        disableCommentMode
      } = t40 === undefined ? {} : t40;
      return onUpdateCollaborationSidebarState(Object.assign({
        [IS_OPEN]: false
      }, disableCommentMode !== undefined ? {
        isCommentModeActive: !disableCommentMode
      } : {}));
    };
    $[16] = onUpdateCollaborationSidebarState;
    $[17] = t39;
  } else {
    t39 = $[17];
  }
  const t40 = t39;
  let t41;
  if ($[18] !== onUpdateCollaborationSidebarState) {
    t41 = hideEmbeddedComments => onUpdateCollaborationSidebarState({
      [HIDE_EMBEDDED_COMMENTS]: hideEmbeddedComments
    });
    $[18] = onUpdateCollaborationSidebarState;
    $[19] = t41;
  } else {
    t41 = $[19];
  }
  const t42 = t41;
  let t43;
  if ($[20] !== onUpdateCollaborationSidebarState) {
    t43 = moduleId => {
      onUpdateCollaborationSidebarState(deleteCommentOnModuleAction(moduleId));
    };
    $[20] = onUpdateCollaborationSidebarState;
    $[21] = t43;
  } else {
    t43 = $[21];
  }
  const t44 = t43;
  let t45;
  if ($[22] !== collaborationSidebarState || $[23] !== onUpdateCollaborationSidebarState || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16 || $[31] !== t17 || $[32] !== t18 || $[33] !== t19 || $[34] !== t2 || $[35] !== t20 || $[36] !== t21 || $[37] !== t22 || $[38] !== t23 || $[39] !== t24 || $[40] !== t26 || $[41] !== t28 || $[42] !== t3 || $[43] !== t30 || $[44] !== t32 || $[45] !== t34 || $[46] !== t36 || $[47] !== t38 || $[48] !== t4 || $[49] !== t40 || $[50] !== t42 || $[51] !== t44 || $[52] !== t5 || $[53] !== t6 || $[54] !== t7 || $[55] !== t8 || $[56] !== t9) {
    t45 = {
      collaborationSidebarState,
      onUpdateCollaborationSidebarState,
      appName: t2,
      enabledFeatures: t3,
      objectType: t4,
      objectId: t5,
      ctaUrl: t6,
      isEmbeddedCommentingEnabled: t7,
      isOpen: t8,
      tab: t9,
      modulesWithReplies: t10,
      replyCounts: collaborationSidebarState.replyCounts,
      isCommentModeActive: t11,
      hideEmbeddedComments: t12,
      selectedChildAsset: collaborationSidebarState.SELECTED_ASSET,
      commentThread: t13,
      commentsFilter: t14,
      assetsLastUpdated: t15,
      isEmbeddedPopoverOpen: t16,
      embeddedPopoverPlacement: t17,
      embeddedCommentCoordinates: t18,
      embeddedModuleID: t19,
      embeddedPopoverAnchorSelector: t20,
      embeddedMetaDescription: t21,
      isEmbeddedOpenFromCommentMode: t22,
      commentableAreaClickCoordinates: t23,
      deleteCommentRequest: t24,
      openSidebar: t26,
      openComments: t28,
      openTasks: t30,
      openCalendar: t32,
      openApprovals: t34,
      openCopilot: t36,
      openActivityFeed: t38,
      closeSidebar: t40,
      setHideEmbeddedComments: t42,
      deleteCommentOnModule: t44
    };
    $[22] = collaborationSidebarState;
    $[23] = onUpdateCollaborationSidebarState;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
    $[34] = t2;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
    $[39] = t24;
    $[40] = t26;
    $[41] = t28;
    $[42] = t3;
    $[43] = t30;
    $[44] = t32;
    $[45] = t34;
    $[46] = t36;
    $[47] = t38;
    $[48] = t4;
    $[49] = t40;
    $[50] = t42;
    $[51] = t44;
    $[52] = t5;
    $[53] = t6;
    $[54] = t7;
    $[55] = t8;
    $[56] = t9;
    $[57] = t45;
  } else {
    t45 = $[57];
  }
  return t45;
}